var map = {
	"./tips.png": 98898,
	"./tips1.png": 8962,
	"./tips10.png": 27294,
	"./tips11.png": 8896,
	"./tips12.png": 55560,
	"./tips2.png": 55163,
	"./tips3.png": 59579,
	"./tips4.png": 76625,
	"./tips5.png": 47352,
	"./tips6.png": 65527,
	"./tips7.png": 68806,
	"./tips8.png": 16545,
	"./tips9.png": 98521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96807;